import { CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { Injectable, Inject, Directive, Input, NgModule } from '@angular/core';

class CdnConfig {
}

class CdnService {
    constructor(cdnConfigValues) {
        this.cdnConfigValues = cdnConfigValues;
        this.cdnList = [];
        this.nameMapping = {};
        this.addCDNUrl = (cdnBaseUrl) => {
            this.cdnList.push(cdnBaseUrl);
        };
        this.cdnList = cdnConfigValues.cdnList;
        this.nameMapping = cdnConfigValues.nameMapping;
    }
    getCDNUrl(url) {
        if (this.cdnList.length === 0) {
            return url;
        }
        // do not process full URLs
        if (/^https?:\/\//.test(url)) {
            return url;
        }
        url = this.stripLeadingSlash(url);
        const cdnIndex = url.length % this.cdnList.length;
        const cdnPrefix = this.stripTrailingSlash(this.cdnList[cdnIndex]);
        // apply mapping
        const mappingFor = this.nameMapping;
        const mappedUrl = mappingFor[url] || url;
        url = `${cdnPrefix}/${mappedUrl}`;
        return url;
    }
    stripTrailingSlash(url) {
        return url.replace(/\/$/, '');
    }
    stripLeadingSlash(url) {
        return url.replace(/^\//, '');
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnService, deps: [{ token: 'CDN_CONFIG_VALUES' }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: CdnConfig, decorators: [{
                    type: Inject,
                    args: ['CDN_CONFIG_VALUES']
                }] }] });

class CdnDirective {
    constructor(_cdnService, _el) {
        this._cdnService = _cdnService;
        this._el = _el;
        this.element = _el.nativeElement;
    }
    ngOnInit() {
        this.element.src = this._cdnService.getCDNUrl(this.source);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnDirective, deps: [{ token: CdnService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "18.2.13", type: CdnDirective, selector: "[wdpr-ra-angular-cdn]", inputs: { source: "source" }, providers: [CdnService], ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[wdpr-ra-angular-cdn]',
                    providers: [CdnService]
                }]
        }], ctorParameters: () => [{ type: CdnService }, { type: i0.ElementRef }], propDecorators: { source: [{
                type: Input
            }] } });

class CdnModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.13", ngImport: i0, type: CdnModule, declarations: [CdnDirective], imports: [CommonModule], exports: [CdnDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnModule, providers: [
            CdnService,
            {
                provide: 'CDN_CONFIG_VALUES',
                useValue: {
                    cdnList: [],
                    nameMapping: {
                        url: undefined
                    }
                }
            }
        ], imports: [CommonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.13", ngImport: i0, type: CdnModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule],
                    providers: [
                        CdnService,
                        {
                            provide: 'CDN_CONFIG_VALUES',
                            useValue: {
                                cdnList: [],
                                nameMapping: {
                                    url: undefined
                                }
                            }
                        }
                    ],
                    declarations: [CdnDirective],
                    exports: [CdnDirective]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { CdnConfig, CdnDirective, CdnModule, CdnService };
